const logFiles = {
  web: {
    logpath: '/axios/assystEnterprise/standalone/log/',
    logfile: 'server.log'
  },
  search: {
    logpath: '/axios/assystSearchServer/log/',
    logfile: 'assystsearchserver.log'
  },
  reports: {
    logpath: '/axios/assystReportsServer/standalone/log/',
    logfile: 'server.log'
  },
  chat: {
    logpath: '/axios/assystNotificationServer/log/',
    logfile: 'assystchatserver.log'
  },
  smtp: {
    logpath: '/axios/assystEnterprise/standalone/log/',
    logfile: 'smtp.log'
  },
  karaf: {
    logpath: '/axios/assystIPaaS/ipaas/log/',
    logfile: 'karaf.log'
  },
  activemq: {
    logpath: '/axios/activeMQ/data/',
    logfile: 'activemq.log'
  },
  ipaas: {
    logpath: '/axios/assystIPaaS/ipaas/log/',
    logfile: ''
  },
  bridge: {
    logpath: '/axios/assystIPaaS/ipaas/log/bridge/',
    logfile: ''
  },
  acemobile: {
    logpath: '/axios/assystEnterprise/standalone/log/',
    logfile: 'aceMobile.log'
  },
  webapm: {
    logpath: '/axios/assystEnterprise/standalone/log/',
    logfile: 'apm.log'
  },
  reportsapm: {
    logpath: '/axios/assystReportsServer/standalone/log/',
    logfile: 'apm.log'
  },
  notifier: {
    logpath: '/axios/assystEnterprise/standalone/log/',
    logfile: 'notifier.log'
  },
  assystai: {
    logpath: '/axios/Assyst_AI_Service/logs/',
    logfile: ''
  }
}

module.exports = {
  logFiles
}
